//router
// import IndexRouters from "./router/index"

//scss
import "./assets/scss/socialv.scss"
import "./assets/scss/customizer.scss"
// Registers the "remixicon" @font-face used by every `ri-*` icon class
// throughout the app (attendance status buttons, event cards, sidebar,
// etc.) - without this import the font was never loaded outside the
// standalone icon-browser demo page, so those icons rendered as empty glyphs.
import "./assets/vendor/remixicon/fonts/remixicon.css"


// Redux Selector / Action
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// import state selectors
import { setSetting } from './store/setting/actions'
import NetworkBanner from './components/NetworkBanner'


function App(props) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setSetting())
  }, [dispatch])


  return (
    <div className="App">
      {/* <IndexRouters /> */}
      <NetworkBanner />
      {props.children}
    </div>
  );
}

export default App;
